import { LeftOutlined, RightOutlined} from "@ant-design/icons";
import { Row, Col, Table, Empty, Button, Select, Spin } from "antd";
import { useContext, useEffect, useState } from "react";
import { Dropdown} from "semantic-ui-react";
import { useListadoJurados } from "../../../hooks/useListadoJurados";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ModalListado } from "./modal-listado.view";
import { TemplateContext } from "../../../utils/template_context";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";

const { Option } = Select;
export const ListadoPostulaciones = () => {
  let {
    postulaciones,
    setPostulaciones,
    cambiarCantidadPaginas,
    cantidadPaginas,
    coloresEstado,
    obtenerLineaConvocatoria,
    lineaConvocatorias,
    filtros,
    buscarFiltros,
    setTodasLasPostulaciones,
    handleLineaChange,
    loading
  } = useListadoJurados();


  useEffect(() => {
    obtenerLineaConvocatoria();
  }, []);

  const currency = function (number: number) {
    return new Intl.NumberFormat('en-ES', { style: 'currency', currency: 'COP', minimumFractionDigits: 2 }).format(number);
  };

  // Calcular total entregado y número de beneficiarios
  const calcularTotales = () => {
    const totalEntregado = postulaciones.reduce((sum: number, item: any) => {
      const precio = item?.postulacion?.precio;
      if (precio !== null && precio !== undefined && precio !== '') {
        return sum + Number(precio);
      }
      return sum;
    }, 0);
    
    const numeroBeneficiarios = postulaciones.filter((item: any) => 
      item?.estado === "Beneficiario"
    ).length;
    
    return { totalEntregado, numeroBeneficiarios };
  };

  const { totalEntregado, numeroBeneficiarios } = calcularTotales();

  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "md" ? "left" : false,
      dataIndex: "index",
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Propuesta",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (datos) => {
        return (
            <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line"}}>
              {datos.nombre_propuesta}
            </span>
        );
     }
    },
    {
      title: "Código",
      //width: 150,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Estado",
      //width: 150,
      key: "estado",
      render: (datos: any) => {
        return (
            <span style={{ color: coloresEstado[datos.estado] }}>
              {datos.estado}
            </span>
        );
      },
    },
    {
      title: "Total",
      //width: 150,
      render: (datos) => {
        return (
            <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line"}}>
              {currency(datos.postulacion.precio)}
            </span>
        );
     }
    },
    {
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Acciones
          </Col>
        </Row>
      ),
      // width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              <Button
                onClick={() => verMas(datos)}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                Ver Más
              </Button>
            </Col>
          </Row>
      ),
    },
  ];
  const [openModal, setOpenModal] = useState(false);
  const [datos, setDatos] = useState({});
  const verMas = (datos: any) => {
    setOpenModal(true);
    setDatos(datos);
    console.log(datos)
  };
  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  };
  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Registro de pagos" },
  ];

  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c6">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Regístros de pagos
        </div>

        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="body_card">
              <div className="row mb-3">
                <div className="col-12 pb-2 ">
                  <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B pb-2">Filtrar línea convocatoria</span>
                </div>
                <div>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    suffixIcon={<FlechaSelect />}
                    value={filtros.linea_convocatoria}
                    size="large"
                    style={{ width: "100%" }}
                    placeholder="Seleccionar..."
                    onChange={handleLineaChange}
                  >
                    {lineaConvocatorias.slice().reverse().map(({ id, nombre }) => (
                      <Select.Option key={id} value={id}>
                        {nombre}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-blanco-radius m-0"
                onClick={buscarFiltros}
                loading={loading}
                disabled={loading}
              >
                Buscar
              </Button>
            </div>
          </div>
        </div>

        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div
                className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular"
                style={{ paddingBottom: "0%" }}
              >
                Listado de postulaciones
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end align-items-center mb-3 flex-wrap">
                <div className="d-flex align-items-center mx-2">
                  <span className="font-size-14px font-family-Montserrat-Regular">
                    Total entregado en la línea:{" "}
                  </span>
                  <span className="font-size-14px font-family-Montserrat-SemiBold" style={{ color: "#00904C", marginLeft: "4px" }}>
                    {currency(totalEntregado)}
                  </span>
                </div>
                <div className="d-flex align-items-center mx-2 font-color-00904C">
                  <span className="font-size-14px font-family-Montserrat-Regular">
                    Beneficiarios:{" "}
                  </span>
                  <span className="font-size-14px font-family-Montserrat-SemiBold font-color-00904C">
                    {numeroBeneficiarios}
                  </span>
                </div>
                <div className="d-flex align-items-center mx-2">
                  <span className="font-size-14px font-family-Montserrat-Regular">
                    Total:{" "}
                  </span>
                  <span className="font-size-14px font-family-Montserrat-SemiBold font-color-F28C02">
                    {postulaciones.length}
                  </span>
                </div>

                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <span className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </span>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPaginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg/>
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Spin spinning={loading} tip="Cargando...">
                  <Table
                    style={{ borderTop: "1px solid #C4C4C4" }}
                    locale={{
                      emptyText: (
                        <Empty
                          description="No se han diligenciados datos para está sección"
                          style={{ padding: "50px" }}
                        />
                      ),
                    }}
                    pagination={{
                      position: ["bottomRight"],
                      itemRender: itemRenderTable,
                      pageSize: cantidadPaginas,
                    }}
                    dataSource={postulaciones}
                    columns={columns}
                    size="small"
                    bordered={false}
                    summary={(pageData) => {
                      return (
                        <Table.Summary fixed>
                          <Table.Summary.Row style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                            <Table.Summary.Cell index={0} colSpan={4} align="right">
                              <span style={{ fontFamily: "Montserrat-SemiBold", fontSize: "14px" }}>
                                Total entregado en la línea:
                              </span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4} align="right">
                              <span style={{ fontFamily: "Montserrat-SemiBold", fontSize: "14px", color: "#00904C" }}>
                                {currency(totalEntregado)}
                              </span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={5} align="left">
                              <span style={{ fontFamily: "Montserrat-SemiBold", fontSize: "14px", marginLeft: "10px" }}>
                                Beneficiarios: <span style={{ color: "#F28C02" }}>{numeroBeneficiarios}</span>
                              </span>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </Table.Summary>
                      );
                    }}
                  />
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="container-sticky-footer">
        <Col span={12}>
          {/* <Button className="button-blanco-radius">ATRÁS</Button> */}
        </Col>
      </Row>

      {openModal ? (
        <ModalListado
          openModal={openModal}
          setOpenModal={setOpenModal}
          datos={datos}
          setPostulaciones={setPostulaciones}
          setTodasLasPostulaciones={setTodasLasPostulaciones}
          buscarFiltros={buscarFiltros}
        />
      ) : null}
    </div>
  );
};
